import './Contacts.css'
import constants from '../Utils/constants.js'
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { useEffect } from 'react';
import { useState } from 'react';

function checkRequired(fd, f, re) {
    let fv = fd.get(f)
    if(fv === null) return false
    console.log(`${f}:${fv}`)
    return re.test(fv)
}

function Contacts() {
    const captchaLen = 6
    const [captcha, setCaptcha] = useState("")
    const [step, setStep] = useState(1)
    const [okNome, setOkNome] = useState(true)
    const [okCongnome, setOkCongnome] = useState(true)
    const [okEmail, setOkEmail] = useState(true)
    const [okEnte, setOkEnte] = useState(true)
    const [okMessaggio, setOkMessaggio] = useState(true)
    const [okPrivacy, setOkPrivacy] = useState(false)
    useEffect(() => loadCaptchaEnginge(captchaLen), [])
    const sendData = () => {
        let fd = new FormData(document.getElementsByName("contatta")[0])
        let nome = checkRequired(fd, 'nome', /.+/)
        let cognome = checkRequired(fd, 'cognome', /.+/)
        let email = checkRequired(fd, 'email', /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/)
        let ente = checkRequired(fd, 'ente', /.+/)
        let messaggio = checkRequired(fd, 'messaggio', /.+/)
        if(!(nome && cognome && email && ente && messaggio)) {
            setOkNome(nome)
            setOkCongnome(cognome)
            setOkEmail(email)
            setOkEnte(ente)
            setOkMessaggio(messaggio)
        }
        else if(validateCaptcha(captcha)) {
            fetch(`${constants.baseUrl}/contacts.php`, {
                method: 'post',
                body: new URLSearchParams(fd),
            })
            .then(r => {
                console.log(r)
                if (r.ok) {
                    setStep(2);
                }
                else {
                    setStep(3)
                }
            })
        }
    }
    return (
        <div className='container-contatti'>
            <form name="contatta" className='container-dati-cliente'>
                {
                    step === 1
                    ?
                        <>
                            <h1>Contatti</h1>
                            <p>Per contattarci compila i campi sottostanti, dopo di che premi il pulsante "Invia richiesta", oppure inviaci direttamente una mail all'indirizzo: <a href='mailto:info@virtual-logic.it'>info@virtual-logic.it</a>.</p>
                            <input type='text' className={okNome ? '' : 'error-required'} name='nome' placeholder='Nome (obbligatorio)' required></input>
                            <input type='text' className={okCongnome ? '' : 'error-required'} name='cognome' placeholder='Cognome (obbligatorio)' required></input>
                            <input type='email' className={okEmail ? '' : 'error-required'} name='email' placeholder='Email (obbligatorio)' required></input>
                            <input type='text' className={okEnte ? '' : 'error-required'} name='ente' placeholder='Ente / dipartimento (obbligatorio)' required></input>
                            <input type='number' name='telefono' placeholder='Telefono (opzionale)'></input>
                            <textarea type='text' className={okMessaggio ? 'input-richiesta' : 'input-richiesta error-required'} name='messaggio' placeholder='Messaggio (obbligatorio)' required></textarea>
                            <span>
                            <input type="checkbox" name="privacy-policy" checked={okPrivacy} onChange={()=>setOkPrivacy(!okPrivacy)}/>
                            <label htmlFor="privacy-policy">
                                Acconsentendo, ci autorizzi a raccogliere e utilizzare i tuoi dati personali secondo i termini della nostra <a href='/assets/Privacy-policy.pdf'>politica sulla privacy.</a>
                            </label>
                            </span>
                            <span> <LoadCanvasTemplateNoReload/> 
                                <input type='text' name='captcha' value={captcha} 
                                    onChange={(event) => {
                                        event.preventDefault();
                                        setCaptcha(event.target.value);
                                    }}/>
                            </span>
                            <button onClick={event => { event.preventDefault(); sendData();}} disabled={!okPrivacy}>Invia richiesta</button>
                        </>
                    :
                    (step === 2
                    ?
                        <>
                            <h1>Contatti</h1>
                            <p>La sua richiesta è stata presa in carico, verrà ricontattato il prima possibile!</p>
                        </>
                    :
                        <>
                            <h1>Contatti</h1>
                            <p>Si è verificato un errore non previsto. Riprovi più tardi! Se l'errore dovesse persistere potete contattarci all'indirizzo email <a href='mailto:info@virtual-logic.it'>info@virtual-logic.it</a></p>
                        </>
                    )

                }
            </form>
            <iframe className="map" title='Map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800.9492476857044!2d10.981784000000008!3d45.41036299999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0000000000000000%3A0x92e86836b5d736bc!2sVirtual+Logic+S.r.L.!5e0!3m2!1sit!2sit!4v1423587349350"></iframe>
        </div>
    )
}
/*
       
function Contacts() {
    return (
        <div className='container-contatti'>
            <div name="contatta" className='container-dati-cliente'>
                <h1>Contatti</h1>
                <p>Potete contattarci direttamente via mail all'indirizzo <a href="mailto:info@virtual-logic.it">info@virtual-logic.it</a> oppure telefonicamente al numero +39 045 9400017 r.a.</p>
                
            </div>
            <iframe className="map" title='Map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800.9492476857044!2d10.981784000000008!3d45.41036299999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0000000000000000%3A0x92e86836b5d736bc!2sVirtual+Logic+S.r.L.!5e0!3m2!1sit!2sit!4v1423587349350"></iframe>
        </div>
    )
}
*/
export default Contacts